import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../AxiosInterceptor/axiosInterceptor";

const initialState = {
    isActive: false,
    userId: "",
    cns: false,
    mnr: false,
    reports: false,
    loading: true,
    error: false,
    role: 3,
}

export const getRoles = createAsyncThunk('data/getRoles',
    async (_, { rejectWithValue }) => {
        try {
            let userID = localStorage.getItem("email");
            console.log(userID)
            let roleQuery = `
               query {
                GetAuthorizationDetails(userID: "${userID}") {
                  data {
                   isActive,
                   userId,
                   cns,
                   mnr,
                   reports
                  }
                }
              }`
            const response = await axiosInstance.post(process.env.REACT_APP_AUTHORIZATION_DETAIL,
                JSON.stringify({ query: roleQuery, variables: {} })
            );

            if (response.data.errors && response.data.errors.length > 0) {
                const errorMessages = response.data.errors.map(err => err.message).join(', ');
                return rejectWithValue(errorMessages);
            }

            return JSON.stringify(response);
        } catch (err) {
            return rejectWithValue(err.message || 'Unexpected error');
        }
    }
);

const roleSlice = createSlice({
    name: 'role',
    initialState,
    reducers: {
        currentRole: (state, action) => {
            state.role = action.payload
        },
        loader: (state, action) => {
            state.loading = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getRoles.pending, (state) => {
                state.loading = true;
                state.error = false;
            })
            .addCase(getRoles.fulfilled, (state, action) => {
                const response = JSON.parse(action.payload);
                state.loading = false;
                state.error = false;
                state.isActive = response.data.data.GetAuthorizationDetails.data.isActive;
                state.userId = response.data.data.GetAuthorizationDetails.data.userId;
                state.cns = response.data.data.GetAuthorizationDetails.data.cns;
                state.mnr = response.data.data.GetAuthorizationDetails.data.mnr;
                state.reports = response.data.data.GetAuthorizationDetails.data.reports;
            })
            .addCase(getRoles.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            });
    }
})

export const { currentRole } = roleSlice.actions;
export default roleSlice.reducer;